import React from 'react'
import { Avatar, Card, Skeleton, Switch, Row, Col, Meta, Button } from 'antd';
import '../Dashboard/dashboard.css'

export default function loadingCard() {
  return (
    <Card className={'card'}
    loading={true}
    style={{ marginRight: '10px' }}
    > 
    <Button type='primary'>
      Vehicle Specifications
    </Button>
    </Card>
  )
}
